import { render, staticRenderFns } from "./userRecord.vue?vue&type=template&id=7e37579d&scoped=true&"
import script from "./userRecord.vue?vue&type=script&lang=js&"
export * from "./userRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e37579d",
  null
  
)

export default component.exports